import axiosWithToken from "axiosWithToken";
import { CommunityAcessTokenResponse } from "./types";
import axios from "axios";

const baseURL2 = process.env.REACT_APP_BASEURL2;

export const getCommunityAccessToken = async () => {
  try {
    const response = await axiosWithToken.post<CommunityAcessTokenResponse>(
      `${baseURL2}api/community/access-token`
    );
    return {
      data: response.data,
    };
  } catch (err: any) {
    throw err;
  }
};

export const setCookieForCircleAuthentication = async (token: string) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_CIRCLE_COOKIE_AUTH_URL || "",
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return {
      data: response.data,
    };
  } catch (err: any) {
    return {
      success: false,
      error: err?.response?.data?.message || "Failed to fetch token",
    };
  }
};
